import axios, { AxiosRequestConfig } from "axios";
import Uri from "jsuri";
import { applyGzipMiddleware } from "./GzipMiddleware";
import { API_BASE_URL, APP_BASE_PATH } from "constants/AppConstants";

export const isInstanceOfUri = (config: AxiosRequestConfig) => {
  const url = config.url as any;
  return url instanceof Uri;
};

const fleetlogicAPI = axios.create({
  baseURL: "",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json"
  }
});

const ABSOLUTE_URL_PATTERN = /^([a-z][a-z\d+\-.]*:)?\/\//i;
const VERSIONED_REST_API_PATTERN = /(^|\/)rest-api\/(v[12])(?=\/|\?|#|$)/;

const applyVersionedRestApiPath = (url: string) => {
  return url.replace(VERSIONED_REST_API_PATTERN, "$1rest-apis/$2");
};

const hasApiBaseUrl = (url: string) => {
  return url === API_BASE_URL || url.startsWith(`${API_BASE_URL}/`);
};

const hasAppBasePath = (url: string) => {
  return Boolean(
    APP_BASE_PATH &&
      (url === APP_BASE_PATH || url.startsWith(`${APP_BASE_PATH}/`))
  );
};

const applyApiBaseUrl = (url: string) => {
  url = applyVersionedRestApiPath(url);

  if (!API_BASE_URL || ABSOLUTE_URL_PATTERN.test(url)) {
    return url;
  }

  if (hasApiBaseUrl(url) || hasAppBasePath(url)) {
    return url;
  }

  return `${API_BASE_URL}${url.startsWith("/") ? "" : "/"}${url}`;
};

fleetlogicAPI.interceptors.request.use(config => {
  config = applyGzipMiddleware(config);

  if (config.url instanceof Uri) {
    config.url = config.url.toString();
  }
  if (typeof config.url === "string") {
    config.url = applyApiBaseUrl(config.url);
  }
  const token = localStorage.getItem("jwtToken");
  if (token) {
    config.headers.Authorization = `JWT ${token}`;
  }
  if (config.url && isInstanceOfUri(config)) {
    config.url = config.url.toString();
  }
  return config;
});

fleetlogicAPI.interceptors.response.use(
  (response) => {
    if (response.config.responseType === "json" && typeof response.data === "string") {
      try {
        response.data = JSON.parse(response.data);
      } catch {
        // Ignore parse error, keep as string
      }
    }
    return response;
  },
  (error) => {
    const errData = error.response?.data;
    if (
      typeof errData === "string" &&
      error.config?.responseType === "json"
    ) {
      try {
        error.response.data = JSON.parse(errData);
      } catch {
        // leave as string if parsing fails
      }
    }

    return Promise.reject(error);
  }
);

export default fleetlogicAPI;
